import { api } from './api';
import {
  Relatorio,
  RelatorioCategoria,
  RelatorioComentario,
  CreateRelatorioDTO,
  UpdateRelatorioDTO,
  RelatorioEstatisticas,
} from '../types/relatorios';

export const relatoriosAPI = {
  // Listar categorias
  listarCategorias: async (idGrupo?: string): Promise<RelatorioCategoria[]> => {
    const response = await api.get('/categorias', {
      params: { id_grupo: idGrupo },
    });
    return response.data;
  },

  // Estatísticas
  getEstatisticas: async (idGrupo: string, admin: boolean = false): Promise<RelatorioEstatisticas> => {
    const response = await api.get(`/grupos/${idGrupo}/relatorios/estatisticas`, {
      params: { admin },
    });
    return response.data;
  },

  // Criar relatório
  criar: async (data: CreateRelatorioDTO): Promise<Relatorio> => {
    const response = await api.post('/relatorios', data);
    return response.data;
  },

  // Listar meus relatórios
  listarMeus: async (idGrupo: string, idTurma?: string): Promise<Relatorio[]> => {
    const response = await api.get(`/grupos/${idGrupo}/relatorios/meus`, {
      params: { id_turma: idTurma },
    });
    return response.data;
  },

  // Listar todos os relatórios (admin)
  listarTodos: async (idGrupo: string, idTurma?: string): Promise<Relatorio[]> => {
    const response = await api.get(`/grupos/${idGrupo}/relatorios`, {
      params: { id_turma: idTurma },
    });
    return response.data;
  },

  // Buscar relatório específico
  buscarPorId: async (id: string, admin: boolean = false): Promise<Relatorio> => {
    const response = await api.get(`/relatorios/${id}`, {
      params: { admin },
    });
    return response.data;
  },

  // Atualizar relatório
  atualizar: async (id: string, data: UpdateRelatorioDTO): Promise<Relatorio> => {
    const response = await api.put(`/relatorios/${id}`, data);
    return response.data;
  },

  // Enviar relatório
  enviar: async (id: string): Promise<Relatorio> => {
    const response = await api.put(`/relatorios/${id}/enviar`);
    return response.data;
  },

  // Confirmar recebimento (admin)
  confirmar: async (id: string): Promise<Relatorio> => {
    const response = await api.put(`/relatorios/${id}/confirmar`);
    return response.data;
  },

  // Excluir relatório
  excluir: async (id: string): Promise<void> => {
    await api.delete(`/relatorios/${id}`);
  },

  // Adicionar comentário
  adicionarComentario: async (id: string, comentario: string): Promise<RelatorioComentario> => {
    const response = await api.post(`/relatorios/${id}/comentarios`, { comentario });
    return response.data;
  },
};
